(function () {
    var ATTR_KEY = "digital_consent";
    var ATTR_TS_KEY = "digital_consent_ts";

    function isoNow() {
        try {
            return new Date().toISOString();
        } catch (e) {
            return "";
        }
    }

    function setCartAttributes(checked) {
        var attrs = {};
        if (checked) {
            attrs[ATTR_KEY] = "yes";
            attrs[ATTR_TS_KEY] = isoNow();
        } else {
            attrs[ATTR_KEY] = "no";
            attrs[ATTR_TS_KEY] = "";
        }
        fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ attributes: attrs })
        }).catch(function (err) {
            console.error("digital-consent: cart update error", err);
        });
    }

    function showError(container, show) {
        if (!container) return;
        var err = container.querySelector(".digital-consent__error");
        if (err) {
            err.style.display = show ? "block" : "none";
        }
    }

    function setButtonState(btn, enabled) {
        if (!btn) return;
        btn.disabled = !enabled;
        btn.setAttribute("aria-disabled", (!enabled).toString());
        if (enabled) {
            btn.classList.remove("button--disabled");
            btn.style.opacity = "1";
            btn.style.pointerEvents = "auto";
            btn.style.cursor = "pointer";
            btn.style.backgroundColor = "";
        } else {
            btn.classList.add("button--disabled");
            btn.style.opacity = "0.5";
            btn.style.pointerEvents = "none";
            btn.style.cursor = "not-allowed";
            btn.style.backgroundColor = "#ccc";
        }
    }

    function bindCartPage() {
        var container = document.querySelector("[data-digital-consent]");
        if (!container) return;
        if (container.dataset.bound === "true") return;
        container.dataset.bound = "true";

        var checkbox = container.querySelector(".digital-consent__checkbox");
        var checkoutButton = document.querySelector("form.cart-recap button[name='checkout']");
        if (!checkbox || !checkoutButton) return;

        function syncUI() {
            var enabled = checkbox.checked;
            setButtonState(checkoutButton, enabled);
        }

        syncUI();
        showError(container, false);

        checkbox.addEventListener("change", function () {
            syncUI();
            showError(container, false);
            setCartAttributes(checkbox.checked);
        });

        var form = checkoutButton.closest("form");
        if (form) {
            form.addEventListener("submit", function (e) {
                if (!checkbox.checked) {
                    e.preventDefault();
                    e.stopPropagation();
                    showError(container, true);
                    checkbox.focus();
                }
            }, true);
        }
    }

    function bindMiniCart() {
        var form = document.getElementById("mini-cart");
        if (!form) return;
        var container = form.querySelector("[data-digital-consent-drawer]");
        if (!container) return;
        if (container.dataset.bound === "true") return;
        container.dataset.bound = "true";

        var checkbox = container.querySelector(".digital-consent__checkbox");
        var checkoutButton = form.querySelector("button[name='checkout']");
        if (!checkbox || !checkoutButton) return;

        function syncUI() {
            var enabled = checkbox.checked;
            setButtonState(checkoutButton, enabled);
        }

        syncUI();
        showError(container, false);

        checkbox.addEventListener("change", function () {
            syncUI();
            showError(container, false);
            setCartAttributes(checkbox.checked);
        });

        form.addEventListener("submit", function (e) {
            if (!checkbox.checked) {
                e.preventDefault();
                e.stopPropagation();
                showError(container, true);
                checkbox.focus();
            }
        }, true);
    }

    function init() {
        bindCartPage();
        bindMiniCart();
    }

    document.addEventListener("DOMContentLoaded", init);
    document.addEventListener("cart:updated", init);
    document.addEventListener("cart:refresh", init);

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === "childList" || mutation.type === "attributes") {
                init();
            }
        });
    });

    var targetNode = document.body;
    if (targetNode) {
        observer.observe(targetNode, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["aria-hidden", "class"]
        });
    }

    setInterval(init, 500);
})();
